import { slideFileName } from './exportFileNames';

/** Packs rendered slide data URLs (in order) into a ZIP blob. Every slide
 *  must be present — a partial carousel is never downloaded. JSZip is loaded
 *  on demand so the editor bundle does not carry it. */
export async function buildCarouselZip(
  dataUrls: Array<string | null>,
  format: 'png' | 'jpeg',
): Promise<Blob> {
  const { default: JSZip } = await import('jszip');
  const zip = new JSZip();
  const ext = format === 'png' ? 'png' : 'jpg';
  dataUrls.forEach((dataUrl, index) => {
    const payload = dataUrl?.split(',', 2)[1];
    if (!dataUrl || !payload) throw new Error(`slide ${index + 1} is missing`);
    zip.file(slideFileName(index, ext), payload, { base64: true });
  });
  return zip.generateAsync({ type: 'blob' });
}
